import { combineReducers } from "redux";
import createNamedWrapperReducer from "@frameworks/web/redux/feature/Markets/Common/Reducers/wrapperReducer";
import ContractStatement from "./ContractStatement";
import ContractCommodity from "./ContractCommodity";
export default combineReducers({
    contract: createNamedWrapperReducer(ContractStatement, "Contract"),
    contractCommodity: createNamedWrapperReducer(ContractCommodity, "ContractCommodity"),
});
